/* Publish by EComposer at 2026-10-14 09:35:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2u1xaekvb2j"]=  window.__ectimmers["ecom-2u1xaekvb2j"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2u1xaekvb2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2u1xaekvb2j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nvd5sdqlpqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nvd5sdqlpqf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lx2up9omn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lx2up9omn', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 try{
 
} catch(error){console.error(error);}
} catch(error){console.error(error);}